module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingSave),
      expression: "loadingSave",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": 'Processando...' + (_vm.requestParam.uploadProgress != null ? '\n' + _vm.requestParam.uploadProgress + '%' : '')
    }
  }, [_c('ed-modal', {
    attrs: {
      "title": _vm.formData.id == 0 ? 'Novo Anexo' : 'Editar Anexo',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.loadingSave,
      "onSave": _vm.salvar,
      "width": "80%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.exameItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })]), _vm._v(" "), (_vm.formData.id == 0) ? _c('ed-alert', {
    attrs: {
      "title": "Instruções",
      "type": "warning"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('ul', [_c('li', [_vm._v("O arquivo não deve exceder 50MB de tamanho")]), _vm._v(" "), _c('li', [_vm._v("Os formatos dos arquivos devem estar em PDF, ZIP, JPG, PNG ou JPEG")]), _vm._v(" "), _c('li', [_vm._v("Todos o arquivos enviados que não corresponderem a uma IMAGEM, serão convertidos em IMAGEM automaticamente.")]), _vm._v(" "), _c('li', [_vm._v("Só é possível enviar 1 arquivo por vez. Se precisar enviar vários arquivos, você deve compactar os mesmo no formato ZIP e envia-los. Assim o sistema consegue desconpactar e salvar corretamente no servidor.")])])])]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b9804eb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/anexo/editar.vue
// module id = 1479
// module chunks = 45